import { cardItems } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '专题策划': 'bg-primary-100 text-primary-700',
  '编辑精选': 'bg-accent-100 text-accent-700',
  '热门分类': 'bg-secondary-100 text-secondary-700',
  '深度观察': 'bg-primary-100 text-primary-700',
  '观影指南': 'bg-accent-100 text-accent-700',
  '怀旧经典': 'bg-secondary-100 text-secondary-700',
  '娱乐放松': 'bg-primary-100 text-primary-700',
};

const cardImages = [
  "https://readdy.ai/api/search-image?query=Warm%20summer%20cinematic%20abstract%20visual%20with%20golden%20sunset%20gradients%2C%20film%20reel%20and%20popcorn%20inspired%20geometric%20shapes%2C%20movie%20marathon%20vibe%2C%20modern%20streaming%20platform%20aesthetic%2C%20no%20text%2C%20warm%20nostalgic%20lighting&width=800&height=600&seq=card-1-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Dark%20suspenseful%20abstract%20visual%20with%20deep%20shadows%20and%20amber%20highlights%2C%20mysterious%20geometric%20patterns%20reminiscent%20of%20crime%20scene%20evidence%2C%20thriller%20atmosphere%2C%20no%20text%2C%20dramatic%20contrast%20lighting&width=800&height=600&seq=card-2-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Romantic%20soft%20abstract%20visual%20with%20peach%20and%20rose%20gradients%2C%20flowing%20organic%20shapes%2C%20Korean%20drama%20inspired%20elegant%20aesthetic%2C%20gentle%20atmospheric%20composition%2C%20no%20text%2C%20dreamy%20warm%20lighting&width=800&height=600&seq=card-3-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Epic%20fantasy%20abstract%20visual%20with%20rich%20coral%20and%20golden%20gradients%2C%20dynamic%20flowing%20energy%20waves%2C%20Chinese%20animation%20inspired%20grand%20composition%2C%20celestial%20elements%2C%20no%20text%2C%20majestic%20warm%20lighting&width=800&height=600&seq=card-4-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cozy%20weekend%20cinematic%20abstract%20visual%20with%20warm%20amber%20and%20terracotta%20gradients%2C%20layered%20relaxing%20geometric%20shapes%2C%20home%20theater%20atmosphere%2C%20no%20text%2C%20comforting%20golden%20hour%20lighting&width=800&height=600&seq=card-5-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Nostalgic%20retro%20abstract%20visual%20with%20sepia%20and%20warm%20gold%20gradients%2C%20classic%20Hong%20Kong%20cinema%20inspired%20geometric%20elements%2C%20vintage%20film%20texture%2C%20no%20text%2C%20warm%20nostalgic%20lighting&width=800&height=600&seq=card-6-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Fun%20cheerful%20abstract%20visual%20with%20vibrant%20coral%20and%20peach%20gradients%2C%20playful%20bouncing%20circular%20shapes%2C%20entertainment%20show%20atmosphere%2C%20no%20text%2C%20bright%20joyful%20warm%20lighting&width=800&height=600&seq=card-7-2026&orientation=landscape",
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-3">
            内容推荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精彩专题
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            水果视频平台编辑精心策划的影视内容专题
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {cardItems.map((item, i) => (
            <div
              key={i}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200 overflow-hidden cursor-pointer"
            >
              <div className="relative aspect-[4/3] bg-background-200 overflow-hidden">
                <img
                  src={cardImages[i]}
                  alt={`${item.title} - 芭乐视频精彩专题`}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 flex flex-col gap-2">
                <h3 className="font-heading font-semibold text-sm text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}